/**
 * Sub Nav Component
 * 서브 네비게이션 컴포넌트 - Swiper 기반
 */

export class SubNav {
    constructor() {
        this.container = null;
        this.carousel = null;
        this.list = null;
        this.swiper = null;
        this.resizeObserver = null;
        this.initSubNav();
    }

    initSubNav() {
        console.log("initSubNav()");
        const SELECTOR = "#sub-nav-swiper";

        const el = document.querySelector(SELECTOR);
        if (!el) return;

        this.container = document.querySelector(".no-sub-nav__container");
        this.carousel = document.querySelector(".no-sub-nav__carousel");
        this.list = document.querySelector(".no-sub-nav__list");

        if (!this.container || !this.carousel || !this.list) return;

        this.swiper = new Swiper(el, {
            slidesPerView: "auto",
            spaceBetween: 8,
            navigation: {
                nextEl: ".no-sub-nav__button--next",
                prevEl: ".no-sub-nav__button--prev",
            },
            on: {
                init: (swiper) => {
                    const activeIndex = swiper.slides.findIndex((slide) =>
                        slide.classList.contains("--active")
                    );

                    if (activeIndex !== -1) {
                        swiper.slideTo(activeIndex);
                    }

                    // 초기 로드 시 정렬 체크 (Swiper DOM 조작 후)
                    requestAnimationFrame(() => {
                        this.checkAlignment();
                    });
                },
            },
        });

        // ResizeObserver로 리사이즈 감지
        if (window.ResizeObserver) {
            this.resizeObserver = new ResizeObserver(() => {
                this.checkAlignment();
            });
            this.resizeObserver.observe(this.container);
            this.resizeObserver.observe(this.list);
        } else {
            // ResizeObserver 미지원 시 window resize 이벤트 사용
            window.addEventListener("resize", () => {
                this.checkAlignment();
            });
        }

        // 초기 체크 (Swiper 초기화 전에 한 번 체크)
        requestAnimationFrame(() => {
            this.checkAlignment();
        });
    }

    checkAlignment() {
        if (!this.container || !this.carousel || !this.list) return;

        const containerWidth = this.container.offsetWidth;
        const listWidth = this.list.offsetWidth;

        // 리스트가 컨테이너보다 크면 flex-start, 아니면 center
        if (listWidth > containerWidth) {
            this.carousel.classList.remove("--center");
        } else {
            this.carousel.classList.add("--center");
        }
    }
}
